var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1618_5783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17L18.5 20L21.5 17",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11L18.5 20",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24L22 24",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1618_5783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "transparent",
    transform: "translate(11.5 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadArrow);
export default __webpack_public_path__ + "static/media/icon-download-arrow.3e8045e951923f24660f0e9c7bfc4303.svg";
export { ForwardRef as ReactComponent };